
import { FlatList, StyleSheet, Text, TouchableOpacity, View } from 'react-native'
import { Theme, ThemedText } from '@app/theme'
import BankSelectionCard from './BankSelectionCard'
import { ThemedView } from '@app/theme'
import { Bank } from '../types/bankVerify'
import { PrivateStackParamList } from '@app/navigationApp/types'
import { NativeStackNavigationProp } from '@react-navigation/native-stack'
import Button from '@app/sharedComponents/Button/Button'
import ROUTE from '@app/navigationApp/routes'
import { ColorTokens } from '@voltmoney/schema'
import { useMemo } from 'react'
import SecureFetchBadge from './SecureFetchBadge'
import { ThemedTouchableOpacity } from '@app/theme/Components'
import PlusIcon from '@app/assets/svg/PlusIcon'
import { useTheme } from '@shopify/restyle'
import { useAppSelector } from '@app/store/hooks'


const AccountList = ({ bankAccounts, selectedBank, navigation, isDarkMode, setSelectedBank, handleAddBankAccount, isVerifyingBankAccount, handleVerifyBankAccount }: { bankAccounts: Bank[], selectedBank: Bank | null, navigation: NativeStackNavigationProp<PrivateStackParamList, 'BANK_ACCOUNT_VERIFICATION', undefined>, isDarkMode: boolean, setSelectedBank: (bank: Bank) => void, handleAddBankAccount: () => void, isVerifyingBankAccount: boolean, handleVerifyBankAccount: () => void }) => {
    const areAllBanksFromMFCentral = useMemo(() => bankAccounts.every(bank => bank?.bankFetchSource === 'MFC_FETCH'), [bankAccounts])
    const firebaseParams = useAppSelector((state) => state.firebaseParams);
    const {is_mfc_up} = firebaseParams;
    const { colors } = useTheme<Theme>()


    return (
        <>
            <ThemedView paddingTop='2xl' paddingHorizontal='lg'>
                <ThemedText variant='h5s' mt='md'>Select bank account for receiving cash</ThemedText>
                {/* TODO : add bank account navigation */}
                <ThemedView mt='sm'>
                    <ThemedTouchableOpacity eventName='VERIFY_BANK_ADD_ANOTHER_BANK_BUTTON' alignSelf='flex-end' flexDirection='row' alignItems='center' onPress={handleAddBankAccount}>
                        <PlusIcon color={colors['icon-action-primary']} size={16} />
                        <ThemedText variant='b3b' ml='sm' color='text-action-primary'>Add bank account</ThemedText>
                    </ThemedTouchableOpacity>
                </ThemedView>
                {is_mfc_up === 'true' && areAllBanksFromMFCentral && <SecureFetchBadge />}

            </ThemedView>
            <FlatList
                style={{ flex: 1, padding: 16 }}
                keyExtractor={(item) => item.accountNumber}
                data={bankAccounts}
                renderItem={({ item }) => <BankSelectionCard isSelected={selectedBank ? selectedBank?.accountNumber + selectedBank?.ifscCode === item.accountNumber + item.ifscCode : false} bank={item} onSelect={setSelectedBank} />}
                contentContainerStyle={styles.listContainer}
            />
            <ThemedView
                style={styles.buttonContainer}
                bg='bg-surface-primary'
                padding='lg'
                borderTopWidth={1}
                borderTopColor='border-primary'
            >
                <ThemedText textAlign='center' variant='b4r' color='text-secondary' mb="lg">
                    We'll match account holder name with PAN records
                </ThemedText>
                <Button
                    label="Verify bank account"
                    type="SOLID"
                    eventName='VERIFY_BANK_BUTTON'
                    size='MD'
                    disabled={!selectedBank || isVerifyingBankAccount}
                    handlePress={handleVerifyBankAccount}
                    bg={colors['text-action-primary']}
                    textColor={isDarkMode ? ColorTokens.Grey_Night : ColorTokens.White}
                />

            </ThemedView>
        </>
    )
}

export default AccountList

const styles = StyleSheet.create({

    buttonContainer: {
        width: '100%',
    },
    listContainer: {
        paddingBottom: 20,
    },
})